import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ChartData } from "chart.js";

import theme from "../../../../components/styles/theme/theme";

interface ChartLegendProps {
  // @ts-ignore
  data: ChartData<"bar">;
}

const ChartLegend: React.FC<ChartLegendProps> = ({ data }) => {
  const reversedDatasets = [...data.datasets].reverse();

  return (
    <Grid
      container
      spacing={{ xs: 1, md: 1 }}
      columns={{ xs: 2, sm: 2, md: 2 }}
      justifyContent="flex-start"
    >
      {reversedDatasets.map((dataset, index) => (
        <Grid
          item
          key={index}
          xs={2}
          sm={1}
          md={1}
          lg={1}
          padding="4px"
          display="flex"
        >
          <Box
            sx={{
              width: "15px",
              minWidth: "15px",
              height: "15px",
              minHeight: "15px",
              backgroundColor: `${dataset.backgroundColor}`,
            }}
          />
          <Typography
            sx={{
              marginLeft: "4px",
              fontSize: "12px",
              color: theme.palette.primary["500"],
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            component="span"
            variant="body1"
          >
            {dataset.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default ChartLegend;
